import ApiBase from './Api'
import { PRFilterKeyword } from 'types/PRFilterKeyword'

const PR_INPUTS_API_PATHS = {
    PR_FILTER_KEYWORDS: '/admin/prfilterkeywords',
}

type KeywordInput = {
    phrase: string
    field: string
    language: string
    negation: boolean
}

class PRFilterKeywordsApi extends ApiBase {
    async findAllFilterKeywords(): Promise<PRFilterKeyword[]> {
        const response: PRFilterKeyword[] = await this._getRequest(PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS)

        return response
    }

    async createFilterKeyword(keyword: KeywordInput): Promise<PRFilterKeyword> {
        const response: PRFilterKeyword = await this._postRequest(PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS, keyword)

        return response
    }

    async updateFilterKeyword(keywordToUpdate: PRFilterKeyword): Promise<PRFilterKeyword> {
        const response = (await this._patchRequest(
            PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS + '/' + keywordToUpdate.id,
            keywordToUpdate,
        )) as PRFilterKeyword

        return response
    }

    async deleteFilterKeyword(id: string): Promise<{ message: string }> {
        const response = (await this._deleteRequest(PR_INPUTS_API_PATHS.PR_FILTER_KEYWORDS + '/' + id)) as {
            message: string
        }

        return response
    }
}

export default PRFilterKeywordsApi
